(ns frontend.view.modals.components.processing-layer
  (:require
   [common.localization :as loc]))

(defn view
  [data-state]
  [:div
   {:class "flex justify-center"}
   [:div
    [:i.fal.fa-spinner.fa-pulse.fa-4x]
    [:span (loc/tr :processing)]]])
